module.exports = __webpack_public_path__ + "img/sPrinCrime_193x205.5e141725.png";